import React from 'react';

import styled from '@emotion/styled';
import { mq } from '../../_style';


export default class TextBlockGrid extends React.Component {
  render() {
    const Container = styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      ${this.props.align === 'right' && 'flex-direction: row-reverse;'}
      ${mq.sp} {
        ${this.props.spWrap && 'flex-wrap: wrap; justify-content: center;'}
        ${this.props.alignSp === 'right' && 'flex-direction: row-reverse;'}
      }
      * + & {
        padding-top: 30px;
        ${this.props.qa === 'true' && 'padding-top: 0px;'}

        ${mq.sp} {
          ${this.props.spqa === 'true' && 'padding-top: 0px;'}
        }
      }
      & > *:not(:last-child) {
        ${this.props.align === 'right' ? 'margin-left: 24px;' : 'margin-right: 24px;' }
        ${mq.sp} {
          ${this.props.alignSp === 'right' ? 'margin-right: 0px;' : 'margin-right: 24px;' }
          ${this.props.spWrap && `
            margin-right: 0;
            margin-left: 0;
            margin-bottom: 30px;
          `}
        }
      }
      & > *:last-child {
        ${mq.sp} {
          ${this.props.alignSp === 'right' ? 'margin-right: 24px;' : 'margin-right: 0px;' }
        }
      }
    `;
    return <Container>{this.props.children}</Container>;
  }
}
